<!-- Search bar input group -->
<p-inputGroup class="border rounded-md h-10 search-dialog-input">
  <!-- Search input field -->
  <input class="text-sm w-full px-4" type="text" pInputText [placeholder]="'aiSearchbarPlaceholder' | translate"
    (keyup.enter)="showDialog()" [(ngModel)]="searchString" />
  <!-- Search button -->
  <button type="button" [icon]="'pi pi-search'" pButton (click)="showDialog()"></button>
</p-inputGroup>

<!-- Search dialog -->
<p-dialog #dialog styleClass="searchDialog"  [appendTo]="'body'" id="searchDialog" [modal]="true" [(visible)]="visible" [focusOnShow]="true"
  [style]="{ width: '47rem'}" [breakpoints]="{ '1199px': '47rem', '786px': '100vw' }" [closeOnEscape]="true"
  [draggable]="false" [resizable]="false" position="top" (onHide)="hideDialog()">
  <!-- Dialog header -->
  <ng-template #header>
    <p-inputGroup class="border rounded-md h-10">
      <!-- Search input field -->
      <input class="text-sm w-full px-4" type="text" [pAutoFocus]="true" pInputText
        [placeholder]="'aiSearchbarPlaceholder' | translate" [(ngModel)]="searchString"
        [readonly]="isImpersonationInProgress()" (keyup.enter)="isImpersonationInProgress() ? null : onSearch()" />
      <!-- Search button -->
      <button type="button"
        [icon]="isImpersonationInProgress() ? 'pi pi-search' : (isSearching() ? '' : 'pi pi-search')"
        [loading]="!isImpersonationInProgress() && isSearching()" pButton [disabled]="isImpersonationInProgress()"
        (click)="isImpersonationInProgress() ? null : onSearch()"></button>
    </p-inputGroup>
  </ng-template>
  @if (isImpersonationInProgress()) {
  <ng-template #content>

    <div class="flex flex-col items-center justify-center h-full pt-5">
      <i class="pi pi-spin pi-spinner" style="font-size: 40px;"></i>
      <p class="p-8 pt-5">{{'impersonationInProgressMsg' | translate}}</p>
    </div>
  </ng-template>
  } @else {
  <!-- Dialog body -->
  <ng-template #content>
    <div (click)="onContentClick($event)">

    <!-- Loader showing when searching the content -->
    @if (isSearching()) {
    <div class="flex flex-col items-center justify-center h-full pt-5">
      <i class="pi pi-spin pi-spinner" style="font-size: 40px;"></i>
      <p class="p-8 pt-5">{{'searchResult.waitingMsg' | translate}}</p>
    </div>
    } @else {
    @if (messageHistory && messageHistory.messages && messageHistory.messages.length > 1) {
    @for (message of messageHistory.messages.slice(1); track message; let index = $index) {
    <div class="text-sm pt-5"
      [class]="{'agent-message' : message.role == role.Agent,'user-message': message.role == role.User,'edit-mode':editModeEnable == index}">
      @if (message.role == role.Agent) {

      @if (message.searchResultType == searchResultTypeEnum.Standard) {
      <gate-search-standard-result [searchMessage]="message"></gate-search-standard-result>
      }
      @else if (message.searchResultType == searchResultTypeEnum.Details) {
      <gate-search-detail-result [searchMessage]="message"></gate-search-detail-result>
      }
      @else if (message.searchResultType == searchResultTypeEnum.Aggregated) {
      <gate-search-aggregate-result [searchMessage]="message"></gate-search-aggregate-result>
      }
      @else if (message.searchResultType == searchResultTypeEnum.License) {
      <gate-search-license-result [searchMessage]="message"></gate-search-license-result>
      }
      @else if (message.searchResultType == searchResultTypeEnum.Impersonate) {
      <gate-search-standard-result [searchMessage]="message"></gate-search-standard-result>
      }@else {
      <markdown [data]="message.freeText" [disableSanitizer]="true"></markdown>
      }
      @if (!loading()) {
      <div class="flex items-center gap-1 mt-1 text-gray-500 feedback-actions">
        <button type="button" pButton
          [icon]="message.submittingFeedbackState === 'up' ? 'pi pi-spin pi-spinner' : (message.feedbackGiven === 'up' ? 'pi pi-thumbs-up-fill' : 'pi pi-thumbs-up')"
          class="p-button-text p-button-rounded p-button-sm !p-1"
          [class.text-green-600]="message.feedbackGiven === 'up'"
          [disabled]="!!message.submittingFeedbackState"
          (click)="onThumbsUp(message, index + 1)"
          [pTooltip]="'aiFeedback.goodFeedback' | translate" tooltipPosition="bottom">
        </button>
        <button type="button" pButton
          [icon]="message.submittingFeedbackState === 'down' ? 'pi pi-spin pi-spinner' : (message.feedbackGiven === 'down' ? 'pi pi-thumbs-down-fill' : 'pi pi-thumbs-down')"
          class="p-button-text p-button-rounded p-button-sm !p-1"
          [class.text-red-600]="message.feedbackGiven === 'down'"
          [disabled]="!!message.submittingFeedbackState"
          (click)="onThumbsDown(message, index + 1)"
          [pTooltip]="'aiFeedback.badFeedback' | translate" tooltipPosition="bottom">
        </button>
      </div>
      }
      }
      @if (message.role == role.User) {
      @if (editModeEnable == index) {
      <p-inputGroup>
        <input class="text-sm w-full h-10" type="text" pInputText [pAutoFocus]="true"
          (keyup.enter)="editPrompt(index,message)" [(ngModel)]="userPrompt" />
        <button type="button" pButton icon="pi pi-check" class="p-button-success"
          (click)="editPrompt(index,message)"></button>
        <button type="button" pButton icon="pi pi-times" class="p-button" (click)="disableEditMode()"></button>
      </p-inputGroup>
      } @else {
      @if (!loading()) {
      <i class="pi pi-pencil text-xs enable-edit-btn" (click)="enableEditMode(index, message.content)"></i>
      }&nbsp;
      <span class="content">{{ message.content}}</span>
      }
      }
    </div>
    }
    @if (loading()) {
    <div class="mx-auto w-full p-4">
      <div class="flex animate-pulse space-x-4">
        <div class="flex-1 space-y-6 py-1">
          <div class="h-2 rounded bg-gray-200"></div>
          <div class="space-y-3">
            <div class="grid grid-cols-3 gap-4">
              <div class="col-span-2 h-2 rounded bg-gray-200"></div>
              <div class="col-span-1 h-2 rounded bg-gray-200"></div>
            </div>
            <div class="h-2 rounded bg-gray-200"></div>
          </div>
        </div>
      </div>
    </div>
    }
    } @else {
    @if (!errorMsg) {
    <div class="flex flex-col items-center justify-center h-full">
      <p class="p-8">{{ "searchResult.noResult" | translate }}</p>
    </div>
    } @else if (errorMsg) {
    <div class="flex flex-col items-center justify-center h-full text-red-600">
      <p class="p-8">{{errorMsg}}</p>
    </div>
    }
    }
    <ng-container *ngTemplateOutlet="errorDiv"></ng-container>
    }
    <!-- No results found message -->
    <ng-template #errorDiv>
      @if (errorMsg) {
      <div class="flex flex-col items-center justify-center h-full text-red-600">
        <p class="p-8">{{errorMsg}}</p>
      </div>
      }
    </ng-template>
    </div>
    <p-scrollTop target="parent" [threshold]="100" icon="pi pi-arrow-up" [behavior]="'smooth'" />
  </ng-template>
  <ng-template #footer>
    @if (isSearchResultNotEmpty()) {
    <div class="mt-2 w-full d-block">
      <p-inputGroup class="border rounded-md h-10">
        <!-- Search input field -->
        <input class="text-sm w-full px-4" type="text" [pAutoFocus]="true" pInputText [variant]="'filled'"
          [(ngModel)]="userMessage" [placeholder]="'searchResult.promtePlaceholder'| translate"
          (keyup.enter)="chatWithAI(userMessage)" />
        <!-- Search button -->
        <button type="button" [icon]="'pi pi-send'" [loading]="loading()" class="bg-[var(--brand-color)]" pButton
          (click)="chatWithAI(userMessage)"></button>
      </p-inputGroup>
      <p-divider></p-divider>
    </div>
    }
    <div class="flex justify-between w-full">
      <ul class="commands">
        <li>
          <kbd class="commands-Key">
            <svg width="15" height="15" aria-label="Enter key" role="img">
              <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2">
                <path d="M12 3.53088v3c0 1-1 2-2 2H4M7 11.53088l-3-3 3-3"></path>
              </g>
            </svg>
          </kbd>
          <span>{{'searchResult.toSearch' | translate}}</span>
        </li>
        <li>
          <kbd class="commands-Key">
            <svg width="15" height="15" aria-label="Escape key" role="img">
              <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2">
                <path
                  d="M13.6167 8.936c-.1065.3583-.6883.962-1.4875.962-.7993 0-1.653-.9165-1.653-2.1258v-.5678c0-1.2548.7896-2.1016 1.653-2.1016.8634 0 1.3601.4778 1.4875 1.0724M9 6c-.1352-.4735-.7506-.9219-1.46-.8972-.7092.0246-1.344.57-1.344 1.2166s.4198.8812 1.3445.9805C8.465 7.3992 8.968 7.9337 9 8.5c.032.5663-.454 1.398-1.4595 1.398C6.6593 9.898 6 9 5.963 8.4851m-1.4748.5368c-.2635.5941-.8099.876-1.5443.876s-1.7073-.6248-1.7073-2.204v-.4603c0-1.0416.721-2.131 1.7073-2.131.9864 0 1.6425 1.031 1.5443 2.2492h-2.956">
                </path>
              </g>
            </svg>
          </kbd>
          <span>{{'searchResult.toClose' | translate}}</span>
        </li>
      </ul>
      <div><span class="text-sm">{{'searchResult.poweredBy'| translate}}</span>&nbsp;<b
          class="text-base">{{'searchResult.ai'| translate}}</b></div>
    </div>
  </ng-template>
  }
</p-dialog>

<!-- Feedback detail dialog -->
<p-dialog [header]="'aiFeedback.dialogTitle' | translate" [(visible)]="feedbackDialogVisible" [modal]="true" [style]="{ width: '30rem' }" [draggable]="false" [resizable]="false">
  <div class="flex flex-col gap-4 py-2">
    <div class="flex flex-col gap-1">
      <label class="text-sm font-semibold">{{ 'aiFeedback.problemTypeLabel' | translate }}</label>
      <p-select [options]="problemTypeOptions" [(ngModel)]="selectedProblemType" optionLabel="key" optionValue="value" class="w-full"></p-select>
    </div>
    <div class="flex flex-col gap-1">
      <label class="text-sm font-semibold">{{ 'aiFeedback.detailsOptional' | translate }}</label>
      <textarea pTextarea [(ngModel)]="feedbackComment" rows="4" class="w-full p-2 border rounded-md" [placeholder]="'aiFeedback.placeholder' | translate"></textarea>
    </div>
  </div>
  <ng-template #footer>
    <div class="flex flex-col gap-3 w-full">
      <p class="text-xs text-gray-500 text-left m-0 w-full pt-2">{{ 'aiFeedback.concern' | translate }}</p>
      <div class="flex items-center justify-end gap-2 w-full">
        <button pButton [label]="'aiFeedback.cancel' | translate" class="p-button-text" (click)="feedbackDialogVisible = false"></button>
        <button pButton [label]="(submittingFeedback ? 'aiFeedback.submitting' : 'aiFeedback.submit') | translate" [loading]="submittingFeedback" (click)="submitDetailedFeedback()"></button>
      </div>
    </div>
  </ng-template>
</p-dialog>
